export default __webpack_public_path__ + "static/media/aboutlft.6a0c99ef.jpg";